import React, { useContext, useEffect, useState } from 'react';

import JobListContext from '../../context/jobListContext';
import AppStateContext from "../../context/appStateContext";
import useReactiveFilterForm from '../../../hooks/useReactiveFilterForm';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import useTextCorrection from '../../../hooks/useTextCorrection';

import FilterCheckBox from '../../../components/filterCheckBox';
import FilterRadio from '../../../components/filterRadio';
import FilterSection from '../../../components/filterSection'
import BuildingList from '../../../components/buildingList';
import ActionTypeList from "../../../components/actionTypeList";
import SearchTab from "../../../components/searchTab";
import { period,SLA,status } from './tabContent'

import {
  ClearBtn,
  CloseXBtn,
  Divider,
  FilterFormCtn,
  FilterHead,
  FiltersCtn,
} from './index.style';

import THEME from '../../../assets/styles/config';
import DatePicker from "../../../components/datePicker";

const SearchTabRm: React.FC<any> = (): React.ReactElement => {
  const { openJobDetails, updateOpenJobDetails } = useContext(JobListContext);
  const { contractCriticalCode, contractList, selectedCustomerId, actionCodes } = useContext(AppStateContext);
  const { width } = useWindowDimensions();
  const { titleCase } = useTextCorrection();
  const [showSearchTab, setShowSearchTab] = useState(!(width < THEME.layout.desktopLarge.breakpoint));


  const toggleSearchTab = () => {
    if (showSearchTab) {
      updateOpenJobDetails(true);
    }
    setShowSearchTab(!showSearchTab);
  };

  useEffect(() => {
    if (openJobDetails) {
      setShowSearchTab(false);
    }
  }, [openJobDetails]);

  const {
    listedPeriodFilter,
    slaTabFilters,
    priorityTabFilters,
    statusTabFilters,
    buildingTabFilters,
    actionTabFilters,
    dateTabFilter,
    handleBuildingChange,
    handleActionChange,
    handleListedPeriodChange,
    handleSlaChange,
    handlePriorityChange,
    handleStatusChange,
    handleDateChange,
    handleSubmit,
    clearAllFilters,
  } = useReactiveFilterForm();

  return (
    <SearchTab submitFilter={handleSubmit} showTab={showSearchTab}>
      <FilterFormCtn>
        <FilterHead>
          <span>Search Criteria</span>
          <ClearBtn onClick={clearAllFilters}>Clear</ClearBtn>
        </FilterHead>
        <FiltersCtn>
          <FilterSection title="BUILDING">
            <BuildingList item={contractList[selectedCustomerId]} change={handleBuildingChange} filter={buildingTabFilters}/>
          </FilterSection>
          <Divider/>
          <FilterSection title="LISTED PERIOD">
            {period.map((item) => {
              return <FilterRadio
                key={item.periodCode}
                active={listedPeriodFilter === item.periodCode}
                text={item.text}
                groupName="PeriodRadio"
                value={item.periodCode}
                onClick={handleListedPeriodChange}
              />
            })}
            <DatePicker dates={dateTabFilter} handleDateChange={handleDateChange}/>
          </FilterSection>
          <Divider />
          <FilterSection title="SLA (REQUIRED DATE)">
            {SLA.map(item => {
              return <FilterCheckBox
                key={item.value}
                checked={slaTabFilters === item.value}
                text={item.text}
                value={item.value}
                onChange={handleSlaChange}
              >
                {item.icon}
              </FilterCheckBox>
            })}
          </FilterSection>
          <Divider />
          <FilterSection title="CRITICAL CODE">
            {
              Object.keys(contractCriticalCode).map((item,index) => {
                if(item == 'PM' || item == 'QU') return;
                return <FilterCheckBox
                  key={item}
                  checked={priorityTabFilters == contractCriticalCode[item].PriorityCode}
                  text={titleCase(contractCriticalCode[item].Details)}
                  value={contractCriticalCode[item].PriorityCode}
                  onChange={handlePriorityChange}
                ><div>{contractCriticalCode[item].PriorityCode}</div></FilterCheckBox>
              })
            }
          </FilterSection>
          <Divider />
          <FilterSection title="STATUS">
            {status.map(item => {
              return <FilterCheckBox
                key={item.value}
                checked={statusTabFilters === item.value}
                text={item.text}
                value={item.value}
                onChange={handleStatusChange}
              >
                {item.icon}
              </FilterCheckBox>
            })}
          </FilterSection>
          <Divider/>
          <FilterSection title='TRADE TYPE'>
            <ActionTypeList actions={actionCodes} change={handleActionChange} filter={actionTabFilters}/>
          </FilterSection>
        </FiltersCtn>
      </FilterFormCtn>
    </SearchTab>
  );
};

export default SearchTabRm;
